export default "__VITE_ASSET__BDx2A1a7__"